/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { superVoterAbi } from "@/domains/abis"
import { simulatedTransaction } from "../simulated-transaction"

type VoteMultipleProps = {
  account: Address
  chainId: number
  config: Config
  superVoterAddress: Address
  nftIds: Array<number>
  votePools: Array<Address>
  voteCounts: Array<string>
  maxLock: boolean
}

export const voteMultiple = async ({
  account,
  chainId,
  config,
  superVoterAddress,
  nftIds,
  votePools,
  voteCounts,
  maxLock,
}: VoteMultipleProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: superVoterAbi as Abi,
        account,
        address: superVoterAddress,
        args: [maxLock, nftIds, votePools, voteCounts],
        chainId,
        functionName: "voteMultiple",
      },
    })
    return result
  } catch (error: any) {
    console.error("voteMultiple", error)
    return { success: false, error: error.message, code: error.code }
  }
}
